import { competitionCode } from './WindowContext';

export type StandingsColorConfig = Map<string, { primary: string; secondary?: string }>;

const defaultConfig: StandingsColorConfig = new Map([
  //R16
  ['1', { primary: 'support-01' }],
  //PO
  ['3', { primary: 'support-02' }],
  //R16_PO
  ['2', { primary: 'support-01', secondary: 'support-02' }],
  //ELIMINATED
  ['4', { primary: 'support-04' }],
]);

const uylConfig: StandingsColorConfig = null;

export const legendConfig =
  {
    uyl: uylConfig,
  }[competitionCode?.toLowerCase()] ?? defaultConfig;
